import { Injectable } from '@angular/core';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { Observable } from 'rxjs';
import { ArticleWithTechnicalPropertiesDTO, TechnicalRequirementsVO } from '@article/properties/technical/technical-requirements';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { AssistantName } from './AssistantName';
import { ArticlesWithTechnicalValues } from './articles-with-technical.values';
import { map } from 'rxjs/operators';
import { OverlayBackground } from '@shared/overlay/overlay.type';

class AssistantRequestVO {
  constructor(public technicalRequirements: TechnicalRequirementsVO[],
              public technicalProperties: readonly string[]) {
  }
}

@Injectable({
  providedIn: 'root'
})
export class AssistantDataService {

  constructor(private wagoApiClient: WagoApiClient,
              private localeResourceManager: LocaleResourceManager) {
  }

  // TODO SLK Make technicalProperties fail safe with type
  public searchArticles(
    assistant: AssistantName,
    technicalRequirements: TechnicalRequirementsVO[],
    technicalProperties: readonly string[],
    withOverlay: boolean = false,
  ): Observable<ArticleWithTechnicalPropertiesDTO[]> {
    const locale = this.localeResourceManager.currentLanguage.langKey;
    const request = new AssistantRequestVO(technicalRequirements, technicalProperties);
    return this.wagoApiClient.post<ArticleWithTechnicalPropertiesDTO[]>(
      `assistant/articles?assistantName=${assistant}&locale=${locale}`,
      request,
      null,
      {overlayType: withOverlay ? OverlayBackground.color : null});
  }

  public getArticles<T extends string>(
    assistantName: AssistantName,
    technicalProperties: readonly T[],
  ): Observable<ArticlesWithTechnicalValues<T>> {
    return this.searchArticles(
      assistantName,
      [],
      technicalProperties,
      true
    ).pipe(
      map((articles) => new ArticlesWithTechnicalValues<T>(articles)),
    );
  }
}
